import { Slide } from "packages/lesson/dist/@types";

import { task as task03 } from "../../../../../task/course-05/lesson-17/task-03";

const task: Slide = {
  title: "At the coincidence frequency the transmission loss is compared to the mass law:",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
